const menuItemPallete = (tokens) => {
    return {
        background: {
            color: tokens.menuItemColorBgDefault,
            hover: tokens.menuItemColorBgHover,
            selected: {
                color: tokens.menuItemColorBgSelectedDefault,
                hover: tokens.menuItemColorBgSelectedHover
            },
            disabled: tokens.menuItemColorBgDisabled,
            focus: tokens.menuItemColorBgFocus
        },
        border: {
            color: tokens.menuItemColorBorderDefault,
            hover: tokens.menuItemColorBorderHover,
            selected: {
                color: tokens.menuItemColorBorderSelectedDefault,
                hover: tokens.menuItemColorBorderSelectedHover
            },
            disabled: tokens.menuItemColorBorderDisabled,
            focus: tokens.menuItemColorBorderFocus,
            width: tokens.menuItemBorderWidth,
            radius: tokens.menuItemRadius
        },
        text: {
            color: tokens.menuItemColorTextDefault,
            hover: tokens.menuItemColorTextHover,
            selected: tokens.menuItemColorTextSelected,
            disabled: tokens.menuItemColorTextDisabled,
            focus: tokens.menuItemColorTextFocus
        },
        padding: {
            default: tokens.menuItemPadding,
            // TODO: Tokenize this value
            nested: '16px'
        }
    };
};
export default menuItemPallete;
//# sourceMappingURL=menuItem.js.map